<template>
  <CContainer fluid>
    <h3>Solicitud de Garantía</h3>
    <CForm class="mt-4">
      <CCard>
        <CCardBody>
          <CRow>
            <CCol col="12">
              <CInput
                label="Empresa:"
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.id"
                :isValid="warrantyRequest.id.length > 0"
                @blur="() => {                                            
                    validate()
                }"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol col="3">
              <CSelect
                label="Tipo Producto: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.productType"
                @input="(value) => {                                
                  if(value === 'E'){
                    warrantyRequest.qty = 1
                  }
                  warrantyRequest.code = ''
                  warrantyRequest.serialNumber = ''
                  validate()
                }"
                :options="[
                  {value: 'C', label: 'Computo'},
                  {value: 'I', label: 'Impresión'},
                  {value: 'A', label: 'Accesorios'},
                  {value: 'S', label: 'Suministros'},
                  {value: 'O', label: 'Otros'},
                ]"
              />
            </CCol>
            <CCol col="1" >
              <CInput
                label="Cantidad: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.qty"
                :disabled="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I')"
                @blur="validate()"
              />
            </CCol>
            <CCol col="4" v-if="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I')">
              <CInput
                label="Número Serial: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.serialNumber"
                :isValid="warrantyRequest.productType === 'C' || (warrantyRequest.productType === 'I') ? warrantyRequest.serialNumber.length > 0 : null"
                :disabled="parseInt(warrantyRequest.qty) > 1"
                @blur="validate()"
              />
            </CCol>
            <CCol col="3" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
              <CInput
                label="Código: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.code"
                :isValid="warrantyRequest.productType !== 'E' && (warrantyRequest.productType !== 'I') ? warrantyRequest.code.length > 0 : null"
                @blur="validate()"
              />
            </CCol>
            <CCol col="2" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
              <CInput
                label="Prefijo: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.billPrefix"
                @input="() => {                                
                    
                }"
                @blur="() => {                                            
                    validate()
                }"
              />
            </CCol>
            <CCol col="3" v-if="warrantyRequest.productType !== 'C' && (warrantyRequest.productType !== 'I')">
              <CInput
                label="Número: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.billNumber"
                :isValid="warrantyRequest.billNumber.length > 0"
                @blur="() => {                                            
                    validate()
                }"
              />
            </CCol>
            <CCol sm="12" >
              <CTextarea
                label="Observaciones: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.observations"
                :isValid="warrantyRequest.observations.length > 0"
                @blur="validate()"
              />
            </CCol>
            <CCol sm="12">
              <label class="text-muted font-weight-bold" for="">Archivo Adjunto:</label>
              <CInputFile
                label="Archivo Adjunto: "
                addInputClasses="col-sm-12"
                addLabelClasses="text-muted font-weight-bold"
                :vertical="true"
                :custom="true" 
                @change="(files) => checkFileSize(files)"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <CInput
                label="Persona de Contacto:"
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.name"
                :isValid="warrantyRequest.name.length > 0"
                @blur="validate()"
              />
            </CCol>
            <CCol col="6" sm="6">
              <CInput
                label="Correo Electrónico: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.email"
                :isValid="warrantyRequest.email.length > 0"
                @blur="validate()"
              />
            </CCol>
            <CCol col="4" sm="4">
              <CInput
                label="Teléfono: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="warrantyRequest.tel"
                :isValid="warrantyRequest.tel.length > 0"
                @blur="validate()"
              />
            </CCol>
          </CRow>                            

        </CCardBody>
        <CCardFooter>
          <div class="d-flex justify-content-center">
            <CButton
              color="success"
              class="mr-2"
              :class="isValidForm ? '' : 'disabled'"
              :disabled="!isValidForm"
              @click="createWarrantyRequest()">
              <CIcon name="cil-check-circle" class="mr-2"/>
              <span class="align-middle">Guardar</span>
            </CButton>
            <CButton
              color="danger"
              variant="outline"
              class="mr-2"
              :to="rootPath">
              <CIcon name="cil-x-circle" class="mr-2"/>
              <span class="align-middle">Cancelar</span>
            </CButton>
          </div>
        </CCardFooter>
      </CCard>
    </CForm>

    <CElementCover  v-show="loading"/>
  </CContainer>
</template>
<script>
  import moment from "moment";
  import {
    getCompanyLogo, 
    errorMessage,
    toBase64
  } from "@/general";
  import {
    grabaGarantiaCliente, 
    consultaGarantiaCliente
  } from "@/api";

  const fieldsDetail = [
    { 
      key: "nombre_ArchivoAdjunto", 
      label: "",
      _style:"text-align:center;"
    },   
    { 
      key: "fecha",
      label: "Fecha",
      _style:"text-align:center;"
    },
    { 
      key: "estado_Garantia",
      label: "Estado",
      _style:"text-align:center;"
    },
    { 
      key: "observaciones", 
      label: "Observaciones",
      _style:"text-align:center;"
    },
    { 
      key: "fecha_Creacion", 
      label: "Fecha Creación",
      _style:"text-align:center;"
    }
  ]

  export default {
    data() {
      return {
        fieldsDetail,
        warrantyRequest: {
          id: "",
          billPrefix: "",
          billNumber: "",
          product: "",
          qty: 1,
          serialNumber: "",
          attachmentFile: "",
          observations: "",
          code: "",
          productType: "C",
          name: "",
          tel: "",
          email: ""
        },
        warrantyQuery: {
          prefix: "",
          number: "",
          hash: ""
        },
        warrantyInfo:{},
        loading: false,
        isValidForm: false,
        isValidQueryForm: false,
        companyLogo: "",
        warrantyStatus: {
          "RAD": "Radicada", 
          "PRE": "Producto Recibido", 
          "REV": "Revision", 
          "PRO": "En Proceso",
          "PEN": "Producto para Entrega",
          "FIN": "Finalizada",
          "REC": "Rechazada",
        }
      }  
    },
    methods: {
      moment,
      validate() {
        this.isValidForm = 
          this.warrantyRequest.id.length > 0 && 
          (this.warrantyRequest.productType !== "C" && (this.warrantyRequest.productType !== "I") ? this.warrantyRequest.billNumber.length > 0 : true) && 
          (this.warrantyRequest.observations.length > 0) && 
          (this.warrantyRequest.name.length > 0) && 
          (this.warrantyRequest.tel.length > 0) && 
          (this.warrantyRequest.email.length > 0) && 
          (this.warrantyRequest.productType === "C" || (this.warrantyRequest.productType === "I") ? this.warrantyRequest.serialNumber.length > 0 : this.warrantyRequest.code.length > 0)
      },
      validateQuery() {
        this.isValidQueryForm = this.warrantyQuery.number.length > 0 && (this.warrantyQuery.hash.length > 0)
      },
      async createWarrantyRequest(){
        try {
          this.loading = true
          const attachmentFile = await toBase64(this.warrantyRequest.attachmentFile)
          
          await grabaGarantiaCliente(
            this,
            this.warrantyRequest.id,
            this.warrantyRequest.billPrefix,
            this.warrantyRequest.billNumber,
            this.warrantyRequest.productType,
            this.warrantyRequest.qty,
            this.warrantyRequest.code,
            this.warrantyRequest.serialNumber,
            this.warrantyRequest.observations,
            this.warrantyRequest.name,
            this.warrantyRequest.tel,
            this.warrantyRequest.email,
            this.fileNameAttachment,
            attachmentFile
          )
          this.$store.commit(
            "setAlert",
            { 
              color: "success",
              message: "Acción exitosa",
              show: 5 
            }
          )

          this.$router.push({ path: '/'});
        } catch(error) {
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async getWarrantyInfo(){
        this.loading = true;

        try{
          const {response} = await consultaGarantiaCliente(this, this.warrantyQuery.prefix, this.warrantyQuery.number, this.warrantyQuery.hash);

          this.warrantyInfo = response;
        } catch(error){
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5 
          });
        } finally {
          this.loading = false
        }
      },
      clear() {
        Object.keys(this.warrantyRequest).forEach(key => {
          if (key === "qty") {
            this.warrantyRequest[key] = 1
          } else if (key === "productType") {
            this.warrantyRequest[key] = "C"
          } else {
            this.warrantyRequest[key] = ""
          }
        });
      },
      clearQuery(){
        Object.keys(this.warrantyQuery).forEach(key => {
          this.warrantyQuery[key] = ""
        })
        this.warrantyInfo = {}
      },
      alertEvent(value){
        if (typeof(value) == "boolean") {    
          this.$store.commit("setAlert", { show: false })
        } else {      
          if (!value) {
            this.$store.commit("setAlert", { show: false })
          }
        }
      },
      checkFileSize(files) {
        if (files[0].size/1024/1204 > 5) {
          this.$store.commit("setAlert", { 
              color: "warning", 
              message: "El tamaño del archivo no puede ser de más de 5MB",
              show: 5
            });

            return;
          }

        this.warrantyRequest.attachmentFile = files;
      }
    },
    computed: {
      alert() {
        return this.$store.state.alert
      },
      fileNameAttachment() {
        if (this.warrantyRequest.attachmentFile[0]) {
          return this.warrantyRequest.attachmentFile[0].name;
        } else {
          return "";
        }
      }
    },
    async mounted() {
      const {companyLogo} = await getCompanyLogo()
      this.companyLogo = companyLogo
    }
  }
</script>
